// extracted by mini-css-extract-plugin
module.exports = {"like_num":"like_like_num__2MISD","like":"like_like__21ViN","true":"like_true__3osLT","false":"like_false__2ypqM"};